<template>
  <div>
    <template v-if="btnList.length < 3">
      <template v-for="(item, index) in btnList" :key="index">
        <el-link
          class="mr-10"
          :href="item.href ? item.href(scopeRow) : 'javascript:void(0)'"
          :target="item.target"
          :type="item.type || 'primary'"
          @click="handleCommand(item.command, scopeRow)"
        >
          {{ item.name}}
        </el-link>
      </template>
    </template>

    <template v-else>
      <template v-for="(item, index) in btnList" >
        <template v-if="index < 1">
          <el-link
            class="mr-10"
            :href="item.href ? item.href(scopeRow) : 'javascript:void(0)'"
            :target="item.target"
            :type="item.type || 'primary'"
            @click="handleCommand(item.command, scopeRow)"
            :key="index"
          >
            {{ item.name}}
          </el-link>
        </template>
      </template>
    </template>

    <el-dropdown v-if="btnList.length > 2 && showMoreAction">
      <span class="el-dropdown-link table-handle-more">
        更多
        <el-icon class="el-icon--right">
          <arrow-down />
        </el-icon>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <template v-for="(item, index) in btnList">
            <el-dropdown-item :key="index" v-if="index >= 1 ">
              <el-link
                class="mr-10"
                :href="item.href ? item.href(scopeRow) : 'javascript:void(0)'"
                :target="item.target"
                :type="item.type || 'primary'"
                @click="handleCommand(item.command, scopeRow)"
              >
                {{ item.name}}
              </el-link>
            </el-dropdown-item>
          </template>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>
<script lang='ts'>
import { defineComponent, reactive, toRefs, watch } from 'vue'
import mixin from '@/mixins/index'
import { ArrayRowsItem } from '@/model/Index'

export default defineComponent({
  props: {
    scopeRow: { type: Object, required: true, default: () => null },
    codeList: { type: Array, required: true, default: () => [] },
    permissionName: { type: String, required: true, default: '' },
    showMoreAction: { type: Boolean, required: false, default: true },
    formPage: { type: String, required: false, default: '' }
  },
  emits: ['command-change'],

  setup(props, context) {
    const dataMap = reactive({
      scopeRow: props.scopeRow,
      showMoreAction: props.showMoreAction,
      btnList: [],
      handleCommand(command: any, val: any) {
        context.emit('command-change', command, val)
      }
    })
    const { mixinData } = mixin(dataMap)
    watch(() => props.scopeRow, () => {
      dataMap.scopeRow = props.scopeRow
      let tempList = mixinData.hasPremiessionBtnList(props.codeList)
      if (props.formPage === 'order') {
        const { scopeRow } = props
        if (['退回'].includes(scopeRow.status)) {
          tempList = tempList.filter((item: any) => ['编辑', '提交审批'].includes(item.name))
        } else if (['预订单'].includes(scopeRow.status)) {
          tempList = tempList.filter((item: any) => ['编辑', '提交审批', '生成正式订单'].includes(item.name))
        } else if (['审批通过'].includes(scopeRow.status)) {
          tempList = tempList.filter((item: any) => ['生成正式订单'].includes(item.name))
        }
      }
      tempList = tempList.filter((kk: any) => kk.visible ? kk.visible(props.scopeRow) : true)
      dataMap.btnList = tempList
    }, { immediate: true })

    return { ...toRefs(dataMap), ...toRefs(mixinData) }
  }
})
</script>
